{
  "accountTitle": "Hesap Adı",
  "accountWalletName": "Hesap / Cüzdan Adı",
  "approvedBalance": "Onaylanan Bakiye",
  "approvedRewards": "Onaylanan Ödüller",
  "availableBalance": "Kullanılabilir Bakiye",
  "balance": "Bakiye",
  "bank": "Banka",
  "bnbWallet": "BNB Cüzdanı",
  "buyBnbUsdt": "BNB / USDT Satın Al",
  "buyBnbUsdtText": "Cüzdanınızı fonlamak için doğrudan BNB veya USDT satın alın.",
  "buyCryptoSubtitle": "Güvenle kripto satın alın ve EXALT cüzdanınızı fonlayın.",
  "buyExaltCoin": "EXALT Coin Satın Al",
  "buyExaltOnPancake": "PancakeSwap'ta EXALT Satın Al",
  "connectedWallet": "Bağlı Cüzdan",
  "copied": "Kopyalandı",
  "copyAddress": "Adresi Kopyala",
  "copyContract": "Kontratı Kopyala",
  "copyExaltContract": "EXALT Kontrat Adresini Kopyala",
  "copyFailed": "Kopyalama başarısız",
  "copyIban": "IBAN'ı Kopyala",
  "copyNumber": "Numarayı Kopyala",
  "deposit": "Para Yatır",
  "depositAddress": "Yatırma Adresi",
  "depositFailed": "Para yatırma başarısız oldu.",
  "depositRequest": "Para Yatırma Talebi",
  "depositRequiredFields": "Ad, hesap/cüzdan ve tutar zorunludur.",
  "depositSubmittedSuccessfully": "Para yatırma talebi başarıyla gönderildi.",
  "estimatedExchangeWalletValue": "Tahmini Borsa Cüzdan Değeri",
  "exaltContractCopied": "EXALT kontrat adresi kopyalandı.",
  "exaltWallet": "EXALT Cüzdanı",
  "fakeSupportReminder": "Sahte destek temsilcilerine dikkat edin. Exalt Exchange ekibi asla şifrenizi veya özel anahtarlarınızı istemez.",
  "loadingWallet": "Cüzdan yükleniyor...",
  "lockedBalance": "Kilitli Bakiye",
  "pendingRewards": "Bekleyen Ödüller",
  "readyTradingWithdrawal": "İşlem veya para çekmeye hazır.",
  "refreshBalance": "Bakiyeyi Yenile",
  "securityAdminApproval": "Cüzdana yansımadan önce yönetici onayı gereklidir.",
  "securityBackendApproval": "Para yatırma ve çekme işlemleri arka uç onayı ile korunur.",
  "securityLicensedGateways": "Ödemeler lisanslı ağ geçitleri üzerinden işlenir.",
  "securityNoAutoRelease": "Doğrulama olmadan otomatik token bırakma yapılmaz.",
  "securityReminder": "Güvenlik Hatırlatması",
  "securitySystem": "Güvenlik Sistemi",
  "securityWalletVerification": "Cüzdan sahiplik doğrulaması varlıklarınızı korur.",
  "sellSwapBack": "Sat / Geri Takas Et",
  "sellSwapBackText": "EXALT'ınızı istediğiniz zaman BNB veya USDT'ye geri takas edin.",
  "serverError": "Sunucu hatası.",
  "sessionExpired": "Oturum süresi doldu. Lütfen tekrar giriş yapın.",
  "step1": "Adım 1",
  "step2": "Adım 2",
  "step3": "Adım 3",
  "submitDeposit": "Para Yatırmayı Gönder",
  "submitWithdrawal": "Para Çekmeyi Gönder",
  "swapToExaltText": "BNB veya USDT'nizi EXALT'a takas edin.",
  "totalAssets": "Toplam Varlıklar",
  "totalPortfolioValue": "Toplam Portföy Değeri",
  "transactionHashReference": "İşlem Hash'i / Referans ID",
  "transfer": "Transfer",
  "usdtWallet": "USDT Cüzdanı",
  "useBscReminder": "Her zaman BNB Smart Chain (BEP-20) ağını kullanın.",
  "verifyContractReminder": "İşlem yapmadan önce her zaman resmi kontrat adresini doğrulayın.",
  "waitingAdminApproval": "Yönetici onayı bekleniyor.",
  "wallet": "Cüzdan",
  "walletAddress": "Cüzdan Adresi",
  "walletBankIbanPlaceholder": "Cüzdan Adresi / JazzCash / Easypaisa / Banka Hesabı / IBAN",
  "walletNotConnected": "Cüzdan bağlı değil",
  "walletStatus": "Cüzdan Durumu",
  "walletsSubtitle": "Kripto cüzdanınızı, para yatırma/çekme işlemlerinizi ve ödeme taleplerinizi yönetin.",
  "walletsTitle": "Cüzdanlar",
  "withdraw": "Para Çek",
  "withdrawRequiredFields": "Tutar, hesap adı ve cüzdan/hesap numarası zorunludur.",
  "withdrawalFailed": "Para çekme başarısız oldu.",
  "withdrawalRequest": "Para Çekme Talebi",
  "withdrawalSubmittedSuccessfully": "Para çekme talebi başarıyla gönderildi.",
  "yourName": "Adınız"
}